import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

const prefix = '/api/v1/profiles/me/contributor/wires';

export function useGetFeatureableWires() {
  const common = query => ({ params: { query } });
  const [state, q] = useAxios({
    url: `${prefix}/featureable`,
    method: 'GET',
  }, { manual: true });
  const executeQuery = query => q(common(query));
  return [state, executeQuery];
}

export function useGetFeaturedWires() {
  return useAxios({
    cache: { ignoreCache: true },
    url: `${prefix}/featured`,
    method: 'GET',
  }, { manual: true });
}

export function usePostFeaturedWires() {
  const common = (wireId, oldWireId) => ({
    data: {
      wire_id: wireId,
      ...(oldWireId ? { old_wire_id: oldWireId } : {}),
    },
  });

  const [state, q] = useAxios({
    url: `${prefix}/featured`,
    method: 'POST',
  }, { manual: true });
  const executeQuery = (newId, oldId) => q(common(newId, oldId));
  return [state, executeQuery];
}

export function useDeleteUnfeatureWire(wireId) {
  return useAxios({
    url: `/api/v1/profiles/me/contributor/wires/featured/wire/${wireId}`,
    method: 'DELETE',
  }, { manual: true });
}
